/**
 * QR 行列を inline SVG へ描く。
 *
 * `<img src="data:">` にしないのは、CSP に `img-src data:` を要求させないため
 * （NFR-SEC-01/02）。暗モジュールは 1 本の `<path>` に畳むので、
 * DOM ノードはモジュール数に関係なく 1 個で済む。
 */
import type { QrMatrix } from './qr';

/** 規格が求める余白（4 モジュール）。 */
const QUIET_ZONE = 4;

export function qrSvg(matrix: QrMatrix, label: string): string {
  const extent = matrix.size + QUIET_ZONE * 2;
  const path: string[] = [];

  for (let row = 0; row < matrix.size; row += 1) {
    let col = 0;
    while (col < matrix.size) {
      if (matrix.modules[row * matrix.size + col] !== 1) {
        col += 1;
        continue;
      }
      // 横に続く暗モジュールは 1 本の矩形にまとめる（パスが短くなる）
      let run = 1;
      while (col + run < matrix.size && matrix.modules[row * matrix.size + col + run] === 1) run += 1;
      path.push(`M${col + QUIET_ZONE} ${row + QUIET_ZONE}h${run}v1h-${run}z`);
      col += run;
    }
  }

  return [
    `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ${extent} ${extent}"`,
    ` role="img" aria-label="${escapeAttribute(label)}" shape-rendering="crispEdges">`,
    `<rect width="${extent}" height="${extent}" fill="#fff"/>`,
    `<path d="${path.join('')}" fill="#000"/>`,
    '</svg>',
  ].join('');
}

function escapeAttribute(raw: string): string {
  return raw.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
}
